import { ModalHistoryOrder } from '@/entities/profile-page/historyOrders/ModalHistoryOrder/ui/ModalHistoryOrder.jsx'
import './ui/ModalHistoryOrder.scss'
export default ModalHistoryOrder
